import apiClient from "../api/client";
import { ENDPOINTS } from "../api/endpoints";

const STORAGE_KEY = "loggedInUser";

export const login = async (email, password) => {
  const response = await apiClient.post(ENDPOINTS.auth.login, {
    email,
    password,
  });
  return response.data;
};

export const persistUser = (user) => {
  if (user) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
  }
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearStoredUser = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const formatUserAddress = (address) => {
  if (!address) return "No address";
  if (typeof address === "string") return address;
  const parts = [address.street, address.city, address.country].filter(Boolean);
  return parts.length ? parts.join(", ") : address.city || "No address";
};
